import { externalCompanyIdentifier } from '@/entities/insurance';

export const taxNumberPricedInsurers = [
  externalCompanyIdentifier.Eia,
  externalCompanyIdentifier.ARX,
  externalCompanyIdentifier.Express,
  externalCompanyIdentifier.PZU,
  externalCompanyIdentifier.Usg,
  externalCompanyIdentifier.Ingo,
];

export const vinPricedInsurers = [
  externalCompanyIdentifier.Usg,
];

export const insurerCheckRules = {
  requiringMakeCheck: [
    externalCompanyIdentifier.Knajza,
  ],
  requiringTaxNumberCheck: [
    externalCompanyIdentifier.Vuso,
    ...taxNumberPricedInsurers,
  ],
  requiringTaxNumberCheckByProgram: [
    { insurerId: externalCompanyIdentifier.Vuso, programName: 'Програма2' },
  ],
};
